import React, { lazy, Suspense } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import retry from '../../../../utils/webpack/chunkRetry';
import NotesModuleLoader from '../../../../Notes/redux/drawer/ModuleLoaderLazy';
const DesktopNotesPanel = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "notes_desktop_panel" */ './index')));
const LoadableDesktopNotesPanel = (props)=>{
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableDesktopNotesPanel"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: null
    }, /*#__PURE__*/ React.createElement(NotesModuleLoader, null), /*#__PURE__*/ React.createElement(DesktopNotesPanel, props)));
};
LoadableDesktopNotesPanel.displayName = 'LoadableDesktopNotesPanel';
export default LoadableDesktopNotesPanel;
